export default {
  methods: {
    defaultDesign(){
      return{
        preview_logo: "",
        logo: null,
        header_style: 1,
        info_style: 1,
        title_style: 1,
        items_style: 1,
        footer_style: 1,
        colors: [
            {
                id: 1,
                text: "Color principal",
                color_value: "#0c203d",
                button_text_color: "#FFFFFF",
            },
            {
                id: 2,
                text: "Fondo",
                color_value: "#F0F0F0",
                button_text_color: "#000000",
            },
            {
                id: 3,
                text: "Título",
                color_value: "#000000",
                button_text_color: "#FFFFFF",
            },
            {
                id: 4,
                text: "H1",
                color_value: "#000000",
                button_text_color: "#FFFFFF",
            },
            {
                id: 5,
                text: "Texto",
                color_value: "#000000",
                button_text_color: "#FFFFFF",
            },
            {
                id: 6,
                text: "Texto encabezado",
                color_value: "#000000",
                button_text_color: "#FFFFFF",
            },
        ],
        available_fonts: [
            {
                name: "Open Sans",
            },
            {
                name: "Roboto",
            },
            {
                name: "Lato",
            },
            {
                name: "Noto Sans JP",
            },
            {
                name: "Montserrat",
            },
            {
                name: "Raleway",
            },
            {
                name: "Merriweather",
            },
            {
                name: "Playfair Display",
            },
            {
                name: "Source Sans Pro",
            },
            {
                name: "Roboto Slab",
            },
        ],
        selected_font: "Open Sans",
        view_folio: true,
        view_date_send: true,
        view_date_validity: true,
        view_currency: true,
        view_download_pdf: true,
        view_notes: true,
      };
    },
    configTinymce(placeholder){
      return {
        
        menubar: false,
        plugins: ['autolink link lists autoresize'],
        toolbar:
          'bold italic underline link bullist numlist removeformat',
        branding: false,
        statusbar:false,
        placeholder: placeholder,
        autoresize_bottom_margin: 0,
        content_style: `
          @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap');
          body { 
            color:#030303;
            font-family:'Open Sans';
            font-size:13px;
            font-weight:400;
            margin: 0 !important;
          }
          .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
            color: #B3B3B3;
          }
        `
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    company() {
      return this.$store.state.company
    },
    fullname() {
      return `${this.$store.state.user.name} ${this.$store.state.user.last_name}`
    },
    configuration() {
      return this.$store.state.client.configuration
    },
    permissions(){
      return this.$store.state.client.user.permisos
    },
    planDetails(){
      return this.$store.state.client.planDetails
    },
    adminConfiguration() {
      return this.$store.state.admin.configuration
    },
    userRole(){
      return this.$store.getters.userRole
    },
    cfdiOptions(){
      return [
        {
          label:"Adquisición de mercancias.",
          value:'G01'
        },
        {
          label:"Devoluciones, descuentos o bonificaciones.",
          value:'G02'
        },
        {
          label:"Gastos en general.",
          value:'G03'
        },
        {
          label:"Construcciones.",
          value:'I01'
        },
        {
          label:"Mobilario y equipo de oficina por inversiones.",
          value:'I02'
        },
        {
          label:"Equipo de transporte.",
          value:'I03'
        },
        {
          label:"Equipo de computo y accesorios.",
          value:'I04'
        },
        {
          label:"Dados, troqueles, moldes, matrices y herramental.",
          value:'I05'
        },
        {
          label:"Comunicaciones telefónicas.",
          value:'I06'
        },
        {
          label:"Comunicaciones satelitales.",
          value:'I07'
        },
        {
          label:"Otra maquinaria y equipo.",
          value:'I08'
        },
        {
          label:"Honorarios médicos, dentales y gastos hospitalarios.",
          value:'D01'
        },
        {
          label:"Gastos médicos por incapacidad o discapacidad.",
          value:'D02'
        },
        {
          label:"Gastos funerales.",
          value:'D03'
        },
        {
          label:"Donativos.",
          value:'D04'
        },
        {
          label:"Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación).",
          value:'D05'
        },
        {
          label:"Aportaciones voluntarias al SAR.",
          value:'D06'
        },
        {
          label:"Primas por seguros de gastos médicos.",
          value:'D07'
        },
        {
          label:"Gastos de transportación escolar obligatoria.",
          value:'D08'
        },
        {
          label:"Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.",
          value:'D09'
        },
        {
          label:"Pagos por servicios educativos (colegiaturas).",
          value:'D10'
        },
        {
          label:"Por definir.",
          value:'P01'
        },
      ]
    }
    
  },
  

}
